import { ACTIONS_TYPES } from '~/src/features/videocontrol/Provider/actionTypes';
import type {
    IAction,
    IActionEmptyPayload,
    TCamera,
    TCount,
    TOption,
    TPlace,
    TPlan,
    TPrice,
} from '~/src/features/videocontrol/Provider/types';

export const addCamera = (item: TCamera): IAction<typeof ACTIONS_TYPES.ADD_CAMERA_ITEM, TCamera> => ({
    type: ACTIONS_TYPES.ADD_CAMERA_ITEM,
    payload: item,
});

export const removeCamera = (id: number): IAction<typeof ACTIONS_TYPES.REMOVE_CAMERA_ITEM, number> => ({
    type: ACTIONS_TYPES.REMOVE_CAMERA_ITEM,
    payload: id,
});

export const resetCameras = (): IAction<typeof ACTIONS_TYPES.RESET_CAMERAS_ITEMS, Record<number, TCamera>> => ({
    type: ACTIONS_TYPES.RESET_CAMERAS_ITEMS,
    payload: {},
});

export const incrementCameraCount = (payload: TCount): IAction<typeof ACTIONS_TYPES.INCREMENT_CAMERA_COUNT, TCount> => ({
    type: ACTIONS_TYPES.INCREMENT_CAMERA_COUNT,
    payload,
});

export const decrementCameraCount = (payload: TCount): IAction<typeof ACTIONS_TYPES.DECREMENT_CAMERA_COUNT, TCount> => ({
    type: ACTIONS_TYPES.DECREMENT_CAMERA_COUNT,
    payload,
});

export const setLocationInstall = (payload: TPlace | null): IAction<typeof ACTIONS_TYPES.SET_LOCATION_INSTALL, TPlace | null> => ({
    type: ACTIONS_TYPES.SET_LOCATION_INSTALL,
    payload,
});

export const setPlan = (payload: TPlan | null): IAction<typeof ACTIONS_TYPES.SET_PLAN, TPlan | null> => ({
    type: ACTIONS_TYPES.SET_PLAN,
    payload,
});

export const setOption = (payload: TOption | null): IAction<typeof ACTIONS_TYPES.SET_OPTION, TOption | null> => ({
    type: ACTIONS_TYPES.SET_OPTION,
    payload,
});

export const incrementCameraPriceWithCount = (payload: TPrice):
    IAction<typeof ACTIONS_TYPES.INCREMENT_CAMERA_PRICE_WITH_COUNT, TPrice> => ({
        type: ACTIONS_TYPES.INCREMENT_CAMERA_PRICE_WITH_COUNT,
        payload,
});

export const decrementCameraPriceWithCount = (payload: TPrice):
    IAction<typeof ACTIONS_TYPES.DECREMENT_CAMERA_PRICE_WITH_COUNT, TPrice> => ({
        type: ACTIONS_TYPES.DECREMENT_CAMERA_PRICE_WITH_COUNT,
        payload,
});

export const setResetAll = (): IActionEmptyPayload<typeof ACTIONS_TYPES.SET_RESET_ALL> => ({
    type: ACTIONS_TYPES.SET_RESET_ALL,
});

export const incrementTotalCountCameras = (payload: number): IAction<typeof ACTIONS_TYPES.INCREMENT_TOTAL_COUNT_CAMERAS, number> => ({
    type: ACTIONS_TYPES.INCREMENT_TOTAL_COUNT_CAMERAS,
    payload,
});

export const decrementTotalCountCameras = (payload: number): IAction<typeof ACTIONS_TYPES.DECREMENT_TOTAL_COUNT_CAMERAS, number> => ({
    type: ACTIONS_TYPES.DECREMENT_TOTAL_COUNT_CAMERAS,
    payload,
});

export const resetTotalCountCameras = (): IActionEmptyPayload<typeof ACTIONS_TYPES.RESET_TOTAL_COUNT_CAMERAS> => ({
    type: ACTIONS_TYPES.RESET_TOTAL_COUNT_CAMERAS,
});

export const incrementInjector = (payload: number): IAction<typeof ACTIONS_TYPES.INCREMENT_INJECTOR, number> => ({
    type: ACTIONS_TYPES.INCREMENT_INJECTOR,
    payload,
});

export const decrementInjector = (payload: number): IAction<typeof ACTIONS_TYPES.DECREMENT_INJECTOR, number> => ({
    type: ACTIONS_TYPES.DECREMENT_INJECTOR,
    payload,
});

export const resetInjector = (payload: string): IAction<typeof ACTIONS_TYPES.RESET_INJECTOR, string> => ({
    type: ACTIONS_TYPES.RESET_INJECTOR,
    payload,
});

export const initInjector = (payload: string): IAction<typeof ACTIONS_TYPES.INIT_INJECTOR, string> => ({
    type: ACTIONS_TYPES.INIT_INJECTOR,
    payload,
});
